import crypto from 'node:crypto';

/** Stable content hash for a source file body (empty string when unreadable). */
export function hashSymbolFileContent(source: string | null | undefined): string {
  return crypto.createHash('sha256').update(source ?? '').digest('hex');
}
